import '../node_modules/@babel/polyfill'

window.URLSearchParams = window.URLSearchParams || function (searchString) {
  var self = this;
  self.searchString = searchString;
  self.get = function (name) {
    var results = new RegExp('[\?&]' + name + '=([^&#]*)').exec(self.searchString);
    if (results == null) {
      return null;
    }
    else {
      return decodeURI(results[1]) || 0;
    }
  };
}

import Vue from 'vue'
import VueResource from 'vue-resource'
import VueFormGenerator from 'vue-form-generator'
import VueSlider from 'vue-slider-component'
import jstz from 'jstz';

import App from './App.vue'

import store from './services/store'
import {Dictionary} from './services/mixins'

import GoogleMapsApiLoader from 'google-maps-api-loader'

import VueRouter from 'vue-router';


import fieldCustomcheckbox from "./components/Checkbox.vue";
Vue.component("fieldCustomcheckbox", fieldCustomcheckbox);
import fieldCustomGoogleAddress from "./components/GoogleAddress.vue";
Vue.component("fieldCustomGoogleAddress", fieldCustomGoogleAddress);


import BrowserDetect from '../node_modules/@metabolism/framework/browser'

BrowserDetect();

Vue.use(VueResource);
Vue.use(VueFormGenerator);
Vue.use(VueRouter);

Vue.mixin(Dictionary);

Vue.component('VueSlider', VueSlider);

const timezone = jstz.determine();

function storeTimezone() {
  let d = new Date();
  d.setTime(d.getTime() + (30*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = "timezone=" + timezone.name()+ ";" + expires + ";path=/";
}

Vue.config.productionTip = false;
Vue.http.options.root = process.env.VUE_APP_API_ENDPOINT;
const maintenanceEndDate = process.env.VUE_APP_MAINTENANCE_END_DATE || 'prochainement';

storeTimezone();

// Fonction pour vérifier si le site est en maintenance
async function checkMaintenance() {
  try {
    const response = await fetch('/.maintenance', { method: 'HEAD' });

    if (response.ok) {
      document.head.innerHTML = `
    <title>La Mutuelle Familiale - Deviseur</title>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <link rel="icon" href="https://www.mutuelle-familiale.fr/themes/custom/tailwindcss/favicon.ico" type="image/vnd.microsoft.icon">
    <style>
      body {
        font-family: Avenir, sans-serif;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100vh;
        margin: 0;
        text-align: center;
        background-color: #f7f7f7;
        padding: 2rem;
      }
      img {
        max-width: 250px;
        margin-bottom: 30px;
      }
      h1 {
        font-size: 24px;
        margin-bottom: 16px;
        color: #444;
      }
      p {
        font-size: 16px;
        color: #666;
      }
    </style>
  `;

      document.body.innerHTML = `
        <img src="/img/lmf-logo.png" alt="Logo La Mutuelle Familiale" />
        <h1>Notre deviseur en ligne est en cours de maintenance jusqu’au ${maintenanceEndDate}</h1>
        <p>Vous pouvez nous contacter au <strong>09.71.10.15.15</strong> pour toute demande de devis.</p>
      `;
    } else {
      // Pas en maintenance : lancer l'app Vue
      store.dispatch('loadConfig').then(() => {
        new Vue({ store, render: h => h(App) }).$mount('#app');
      });
    }
  } catch (error) {
    // En cas d'erreur, lancer normalement l'app
    store.dispatch('loadConfig').then(() => {
      new Vue({ store, render: h => h(App) }).$mount('#app');
    });
  }
}

// Appelle la fonction de vérification de maintenance
checkMaintenance();

function resizeIframe(){
  window.parent.postMessage(
      {type:'resize', height:document.body.scrollHeight}, "*")
}
setInterval(resizeIframe, 500);
resizeIframe();

